import { warehouseBankLineApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const WAREHOUSE_BANK_LINE_ACTION_TYPE = createNamedActions('warehouseBankLine', {
  GET_LINES: 'GET_LINES',
  GET_LINE: 'GET_LINE',
  CREATE_LINE: 'CREATE_LINE',
  UPDATE_LINE: 'UPDATE_LINE',
  DELETE_LINE: 'DELETE_LINE',
  MANAGE_ELIGIBILITIES: 'MANAGE_ELIGIBILITIES',
  GET_RATE_HISTORY: 'GET_RATE_HISTORY',
});

export const getLinesAction = catchAsyncActionError(({ warehouseBankId }) => async dispatch => {
  const { data } = await warehouseBankLineApi.getLines(warehouseBankId);

  return dispatch({
    type: WAREHOUSE_BANK_LINE_ACTION_TYPE.GET_LINES,
    payload: data,
    meta: { warehouseBankId },
  });
});

export const getLineAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await warehouseBankLineApi.getLine(params);

  return dispatch({
    type: WAREHOUSE_BANK_LINE_ACTION_TYPE.GET_LINE,
    payload: data,
  });
});

export const createLineAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await warehouseBankLineApi.createLine(params);

  return dispatch({
    type: WAREHOUSE_BANK_LINE_ACTION_TYPE.CREATE_LINE,
    payload: data,
  });
});

export const updateLineAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await warehouseBankLineApi.updateLine(params);

  return dispatch({
    type: WAREHOUSE_BANK_LINE_ACTION_TYPE.UPDATE_LINE,
    payload: data,
  });
});

export const deleteLineAction = catchAsyncActionError(params => async dispatch => {
  await warehouseBankLineApi.deleteLine(params);

  return dispatch({
    type: WAREHOUSE_BANK_LINE_ACTION_TYPE.DELETE_LINE,
    meta: params,
  });
});

export const manageEligibilitiesAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await warehouseBankLineApi.manageEligibilities(params);

  return dispatch({
    type: WAREHOUSE_BANK_LINE_ACTION_TYPE.MANAGE_ELIGIBILITIES,
    payload: data,
    meta: { lineId: params.lineId },
  });
});

export const getRateHistoryAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await warehouseBankLineApi.getRateHistory(params);

  return dispatch({
    type: WAREHOUSE_BANK_LINE_ACTION_TYPE.GET_RATE_HISTORY,
    payload: data,
    meta: { lineId: params.lineId },
  });
});
